import { createStore, createEvent } from "effector";
import { useRef } from "react";


// export const $todos = createStore([]);

export const changeChangedMainBotBlock = createEvent();

export const $changedMainBotBlock = createStore(false).on(changeChangedMainBotBlock, (_, newValue) => newValue);

export const changeTreeSettingsMenu = createEvent();

export const disabledButtonOnOff = createEvent();

export const $disabledButtonOnOff = createStore(true).on(disabledButtonOnOff, (_, newValue) => newValue);

export const $treeSettingsMenu = createStore([]).on(changeTreeSettingsMenu, (_, newValue) => newValue);

export const email = createEvent();

export const $email = createStore('').on(email, (_, newValue) => newValue);

export const company = createEvent();

export const $company = createStore('').on(company, (_, newValue) => newValue);

export const changeOpenTourButton = createEvent();

export const $changedOpenTour = createStore(false).on(changeOpenTourButton, (_, newValue) => newValue);

export const refButtonOnOff = createEvent();
export const $refButtonOnOff = createStore(null).on(refButtonOnOff, (_, newValue) => newValue);

export const changeActiveTabBotSettings = createEvent();

export const $activeTabBotSettings = createStore('1').on(changeActiveTabBotSettings, (_, newValue) => newValue);

export const globalTokenBot = createEvent();

export const $globalTokenBot = createStore('').on(globalTokenBot, (_, newValue) => newValue);


export const events = createEvent();
export const eventsAdd = createEvent();
export const $events = createStore([])
    .on(eventsAdd, (state, newValue) => [...state, newValue])
    .on(events, (_, newValue) => newValue);  
